/**
=========================================================
* Clifford Inu
=========================================================
*/

export default {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
};
